import angular from 'angular'
import workflowBarComponent from './workflowBar.component'

export default angular
  .module('ellipsis.workflowBar', [])
  .component('workflowBar', workflowBarComponent)
